import { useQuery } from "@tanstack/react-query"
import { Guid } from "../app/models/CustomType"
import { ApplicationPermissionFirmwareConstraintGet } from "../app/models/ApplicationPermissionFirmwareConstraint"
import { digitalManagerApi } from "../services/api"

export function useApplicationPermissionFirmwareConstraints(
  applicationId?: Guid,
  permissionId?: Guid
) {
  const {
    data: applicationPermissionFirmwareConstraints = [],
    isLoading: isLoadingApplicationPermissionFirmwareConstraints,
  } = useQuery({
    queryKey: ["applicationPermissionFirmwareConstraints", applicationId, permissionId],
    queryFn: () =>
      digitalManagerApi
        .get<ApplicationPermissionFirmwareConstraintGet[]>(
          `/applications/${applicationId}/permissions/${permissionId}/firmwareConstraints`
        )
        .then((r) => r.data),
    enabled: !!applicationId && !!permissionId,
  })

  return {
    applicationPermissionFirmwareConstraints,
    isLoadingApplicationPermissionFirmwareConstraints,
  }
}
